/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-loop-func */
import { useFirestoreQueryDoc } from "components/hooks/useFirestoreQueryDoc";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { toggleEditEntry } from "redux/organizerScheduling/organizerSchedulingSlice";
import { db, storage } from "../../../services/firebase";
import {
  getDownloadURL,
  ref,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import ButtonLoadingSpinner from "utils/ButtonLoadingSpinner";

import "../../../utils/checkbox.css";
import { collection, getDocs } from "firebase/firestore";
import Spinner from "utils/Spinner";
import { useQueryAllSubCollectionDocs } from "components/hooks/useQueryAllSubCollectionDocs";
import {
  clearSuccess,
  editEntry,
} from "redux/routineScheduling/routineSchedulingSlice";
import EmceeEntrySearchCont from "./EmceeEntrySearchCont";
import EmceeEntryDancerSearchCont from "./EmceeEntryDancerSearchCont";
import { useQueryAllDocs } from "components/hooks/useQueryAllDocs";

const EmceeEditEntry = ({ entryToEdit, compId, currentEvent, setOpenEdit }) => {
  const { data } = useFirestoreQueryDoc("organizers", compId);
  let studios = data?.studio_registrations;

  const { editEntryPending, editEntrySuccess } = useSelector(
    (state) => state.routineScheduling
  );

  const { data: competitionData } = useQueryAllDocs("competitions");
  const compData = competitionData?.filter(
    (item) => item?.compId === compId
  )[0];

  // const { data: compData } = useFirestoreQueryDoc('competitions', compId);
  // console.log("compData", compData);

  const {
    competitionLevel,
    eligibilityDivisions,
    scheduling,
    entryTypes,
    danceGenres,
  } = compData;

  const trueGenreKeys = Object.keys(danceGenres)
    .filter((key) => danceGenres[key] === true)
    .map((item) => item.toLowerCase());

  const dispatch = useDispatch();
  const timestamp = new Date().getTime();

  function formatTimeStamp(timestamp) {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const month = date.toLocaleString("default", { month: "long" });
    const day = date.getDate();
    const year = date.getFullYear();

    const formattedTime = `${hours}:${
      minutes < 10 ? "0" + minutes : minutes
    }, ${month} ${day}, ${year}`;
    return formattedTime;
  }

  const tags = scheduling?.customTags;

  const [initialFormData, setinitialFormData] = useState({
    id: entryToEdit?.id,
    sort_id: entryToEdit?.sort_id,
    event_id: entryToEdit?.event_id,
    event_uid: entryToEdit?.event_uid,
    compId,
    doc_id: entryToEdit?.doc_id,
    entry_count: entryToEdit?.entry_count,
    entry_name: entryToEdit?.entry_name,
    studio_selected: entryToEdit?.studio_selected,
    dancers_selected: entryToEdit?.dancers_selected,
    age_division: entryToEdit?.age_division,
    classification: entryToEdit?.classification,
    entryType: entryToEdit?.entryType,
    genre: entryToEdit?.genre,
    music_url: entryToEdit?.music_url,
    special_tags: entryToEdit?.special_tags,
    checkedIn: entryToEdit?.checkedIn,
    performance_ready: entryToEdit?.performance_ready,
    isCheckedProps: entryToEdit?.isCheckedProps,
    isDancerStarts: entryToEdit?.isDancerStarts,
    status: entryToEdit?.status,
    last_update: formatTimeStamp(timestamp),
    is_scratched: entryToEdit?.is_scratched,
    is_presenting: entryToEdit?.is_presenting,
    is_performing: entryToEdit?.is_performing,
    isRunAround: entryToEdit?.isRunAround,
    category_name: entryToEdit?.category_name,
    locked_entry: entryToEdit?.locked_entry,
    performance_time: entryToEdit?.performance_time,
    locked_entry_time: entryToEdit?.locked_entry_time,
    locked_entry_count: entryToEdit?.locked_entry_count,
  });

  const [formData, setFormData] = useState({
    ...initialFormData,
    // time: addTimeToFormData(initialFormData).time,
  });
  useEffect(() => {
    setFormData((prev) => {
      return {
        ...prev,
        ...initialFormData,
        studio_letter: assignedStudioLetter,
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialFormData]);

  //   to handle form submit
  const [validationError, setValidationError] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();

    if (
      formData?.entry_name &&
      formData?.age_division &&
      formData?.classification &&
      formData?.entryType &&
      formData?.genre &&
      formData?.studio_selected?.length > 0 &&
      formData?.dancers_selected?.length > 0
    ) {
      dispatch(
        editEntry({
          formData,
          compId,
          doc_id: entryToEdit?.doc_id,
          currentEvent,
        })
      );
    } else {
      setValidationError(true);
    }
  }

  const [selectedStudios, setSelectedStudios] = useState(
    formData?.studio_selected || []
  );

  const assignedStudioLetter = (() => {
    const matchingStudioIndex =
      selectedStudios &&
      studios?.findIndex((item) => item?.studio_name === selectedStudios[0]);
    if (matchingStudioIndex >= 0) {
      return String.fromCharCode(65 + matchingStudioIndex); // 65 corresponds to the ASCII code for 'A'
    } else {
      return undefined;
    }
  })();

  //to manage selecting and removing dancers
  const [openDancers, setOpenDancers] = useState(false);
  const [openDancersErr, setOpenDancersErr] = useState(false);
  function toggleOpenDancers() {
    if (selectedStudios?.length > 0) {
      setOpenDancers((prev) => !prev);
    } else {
      setOpenDancersErr(true);
    }
  }

  const [selectedDancers, setSelectedDancers] = useState(
    formData?.dancers_selected
  );

  //===================================================to handle dancer select
  const handleDancerChange = (event) => {
    const dancerId = event.target.value;

    const newDancer = filteredDancerOptions?.filter(
      (each) => each.dancer_uid === dancerId
    )[0];

    const check = selectedDancers?.filter(
      (item) => item?.dancer_uid === dancerId
    );

    if (check?.length > 0) {
      // check if the dancer is already selected based on id
      setSelectedDancers((prevSelectedDancers) =>
        prevSelectedDancers.map((dancer) =>
          dancer?.dancer_uid === dancerId ? newDancer : dancer
        )
      );
    } else {
      setSelectedDancers([...selectedDancers, newDancer]);
    }
    setOpenDancers(false);
  };

  function handleRemoveDancer(dancerName) {
    setSelectedDancers(
      selectedDancers.filter((dancer) => dancer !== dancerName)
    );
  }

  useEffect(() => {
    setFormData((prev) => {
      return {
        ...prev,
        age_division: filteredAgeDivision(
          eligibilityDivisions,
          averageAge
        )[0]?.divisionName.toLowerCase(),
      };
    });
  }, [selectedDancers]);

  //to manage selecting and removing studios
  const [openStudios, setOpenStudios] = useState(false);
  function toggleOpenStudios() {
    setOpenStudios((prev) => !prev);
    setEntryExists(false);
    setOpenDancersErr(false);
  }

  const handleStudioChange = (event) => {
    setSelectedStudios([event.target.value]);
    setEntryExists(false);
    setOpenDancersErr(false);
  };

  function handleRemoveStudio() {
    setSelectedStudios([]);
    setOpenDancersErr(false);
    setSelectedDancers([]);
  }

  const studioId = studios?.filter(
    (item) => item?.studio_name === formData?.studio_selected[0]
  )[0]?.studio_id;

  const [searchingDancers, setsearchingDancers] = useState(false);
  const [dancersFromStudios, setDancersFromStudios] = useState([]);

  useEffect(() => {
    if (studioId) {
      const getAllDancers = async () => {
        setsearchingDancers(true);
        try {
          const dancersRef = collection(db, "competitions", compId, "dancers");
          const dancersSnapshot = await getDocs(dancersRef);

          const dancersData = [];
          dancersSnapshot.forEach((doc) => {
            dancersData.push({ id: doc.id, ...doc.data() });
          });
          const filtered = dancersData?.filter(
            (itm) => itm?.studioId === studioId
          );
          setDancersFromStudios(filtered);
        } catch (error) {
          console.error("Error retrieving dancers:", error);
          // setDancersFromStudios([]);
        } finally {
          setsearchingDancers(false);
        }
      };

      getAllDancers();
    }
  }, [studioId]);

  const filteredDancerOptions = dancersFromStudios
    ?.filter((item) => selectedStudios?.includes(item?.studio_name))
    ?.sort((a, b) => {
      const nameA = a?.first_name.toUpperCase();
      const nameB = b?.first_name.toUpperCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

  // console.log(filteredDancerOptions);

  function handleFormChange(event) {
    const { id, value } = event.target;
    setValidationError(false);
    setOpenDancersErr(false);
    setEntryExists(false);
    setinitialFormData((prev) => {
      return {
        ...prev,
        [id]: typeof value === "string" ? value.toLowerCase() : value,
      };
    });
  }

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    const updatedspecial_tags = checked
      ? [...formData.special_tags, value]
      : formData.special_tags.filter((checkbox) => checkbox !== value);
    setFormData({ ...formData, special_tags: updatedspecial_tags });
    setEntryExists(false);
  };

  const [isCheckedProps, setIsCheckedProps] = useState(
    formData?.isCheckedProps
  );
  const handlePropChange = () => {
    setIsCheckedProps(!isCheckedProps);
    setEntryExists(false);
  };

  const [isDancerStarts, setIsDancerStarts] = useState(
    formData?.isDancerStarts
  );
  const handleDancerStartsChange = () => {
    setIsDancerStarts(!isDancerStarts);
    setEntryExists(false);
  };

  const [isRunAround, setIsRunAround] = useState(formData?.isRunAround);
  const handleRunAroundChange = () => {
    setIsRunAround(!isRunAround);
    setEntryExists(false);
  };

  useEffect(() => {
    setinitialFormData((prev) => {
      return {
        ...prev,
        dancers_selected: selectedDancers,
        studio_selected: selectedStudios,
        isCheckedProps: isCheckedProps,
        isDancerStarts: isDancerStarts,
        isRunAround: isRunAround,
      };
    });
  }, [
    selectedDancers,
    selectedStudios,
    isDancerStarts,
    isCheckedProps,
    isRunAround,
  ]);

  const [entryExists, setEntryExists] = useState(false);
  useEffect(() => {
    if (editEntrySuccess?.success) {
      setOpenEdit(false);
      setEntryExists(false);
      dispatch(clearSuccess());
    } else if (editEntrySuccess?.success === false) {
      setEntryExists(true);
    } else {
      setEntryExists(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editEntrySuccess]);

  // handling edit music upload
  const [musicFile, setMusicFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(null);

  const handleMusicUpload = async (e) => {
    e.preventDefault();
    if (musicFile === null) return;

    try {
      setLoading(true);
      setUploadProgress(0);
      const storageRef = ref(storage, `music/${musicFile.name}`);

      // Check if the file already exists in the storage
      try {
        await deleteObject(storageRef);
      } catch (error) {
        // Ignore the error if the file does not exist
        if (error.code !== "storage/object-not-found") {
          throw error;
        }
      }

      // Upload the file and update the state with the progress
      const uploadTask = uploadBytesResumable(storageRef, musicFile);
      uploadTask.on("state_changed", (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setUploadProgress(progress);
      });

      await uploadTask;

      const url = await getDownloadURL(storageRef);
      setFormData({ ...formData, music_url: url });

      setLoading(false);
      setUploadComplete(musicFile.name);
      setTimeout(() => {
        setUploadComplete(null);
      }, 2000);
    } catch (error) {
      console.error("Error updating music:", error);
      setLoading(false);
    }
  };

  // handling edit discard: reset form data
  // const handleDiscard = (e) => {
  //   e.preventDefault();

  //   if (musicFile) {
  //     const storageRef = ref(storage);
  //     const musicRef = ref(storageRef, `music/${musicFile?.name}`);

  //     deleteObject(musicRef)
  //       .then(() => {
  //         // File deleted successfully, dispatch action to toggle add entry and reset state

  //         setOpenEdit(false);
  //         setEntryExists(false);
  //       })
  //       .catch((error) => {
  //         // An error occurred while deleting the file, handle the error here
  //         setOpenEdit(false);
  //         console.log("Error deleting music:", error);
  //       });
  //   } else {
  //     setOpenEdit(false);
  //   }
  // };

  // extracting the music url from the formData
  const musicUrl = formData?.music_url
    ? formData.music_url
        .slice(
          formData.music_url.indexOf("%") + 3,
          formData.music_url.indexOf("?")
        )
        .replace(/%20/g, " ")
    : null;

  // to filter entrytypes
  function filteredEntryTypes(array, number) {
    return array.filter(
      (obj) => obj.minDancers <= number && obj.maxDancers >= number
    );
  }

  // to filter age division
  function filteredAgeDivision(array, number) {
    return array.filter((obj) => obj.minAge <= number && obj.maxAge >= number);
  }

  function convertDateFormat(dateString) {
    const regex = /^(\d{2})-(\d{2})-(\d{4})$/;
    if (!regex.test(dateString)) {
      return dateString; // Return the original string if not in "mm-dd-yyyy" format
    }

    const parts = dateString.split("-");
    const formattedDate = `${parts[2]}-${parts[0].padStart(
      2,
      "0"
    )}-${parts[1].padStart(2, "0")}`;
    return formattedDate;
  }

  function calculateAge(dateOfBirth) {
    const today = new Date();
    // const birthDate = new Date(dateOfBirth);
    const birthDate = new Date(convertDateFormat(dateOfBirth));

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }

  function calculateAverage(numbers) {
    if (numbers.length === 0) {
      return 0;
    }

    const sum = numbers.reduce((total, num) => total + num, 0);
    const average = sum / numbers.length;

    return Math.floor(average);
  }

  const dobArray = selectedDancers?.map((obj) => obj.date_of_birth);
  const ageArray = dobArray?.map((age) => calculateAge(age));
  const averageAge = calculateAverage(ageArray);

  //to get dancers whose classification is exceeds the selected classification
  const separateClass = selectedDancers?.filter(
    (item) => item?.classification !== formData?.classification
  );
  const currentClass = selectedDancers?.filter(
    (item) => item?.classification === formData?.classification
  );

  //to calculate dancers classification percentages
  function calculatePercentageOfDancerLevel(array) {
    const classificationCount = {};

    array?.forEach((obj) => {
      const classification = obj?.classification?.toLowerCase();
      if (classification in classificationCount) {
        classificationCount[classification]++;
      } else {
        classificationCount[classification] = 1;
      }
    });

    const totalObjects = array?.length;
    const percentageObject = {};

    for (const classificationValue in classificationCount) {
      const count = classificationCount[classificationValue];
      const percentage = (count / totalObjects) * 100;
      percentageObject[classificationValue] = percentage.toFixed(0);
    }

    return percentageObject;
  }

  // console.log("entryToEdit", entryToEdit);

  const assignSortId = (array) => {
    if (array && Array.isArray(array) && array.length > 0) {
      const maxSortId = Math.max(...array.map((obj) => obj?.sort_id || 0));
      const newSortId = maxSortId + 1;

      return newSortId;
    } else {
      // If the allEntries array is empty or not valid, start with sort_id 1
      return 1;
    }
  };

  const { data: allEntries } = useQueryAllSubCollectionDocs(
    "competitions",
    compId,
    "entries"
  );

  useEffect(() => {
    //to dynamically add the entrytpe maxtime
    const myTime = entryTypes?.filter(
      (itm) => itm?.entryTypeName === formData?.entryType
    )[0]?.maxTime;

    setFormData((prev) => {
      return {
        ...prev,
        category_name: `${
          filteredAgeDivision(eligibilityDivisions, averageAge)[0]?.divisionName
        }~${initialFormData?.classification}~${initialFormData?.genre}~${
          filteredEntryTypes(entryTypes, selectedDancers?.length)[0]
            ?.entryTypeName
        }`,
        age_division: filteredAgeDivision(eligibilityDivisions, averageAge)[0]
          ?.divisionName,
        entryType: filteredEntryTypes(entryTypes, selectedDancers?.length)[0]
          ?.entryTypeName,
        sort_id:
          entryToEdit?.category_name === formData?.category_name
            ? entryToEdit?.sort_id
            : assignSortId(allEntries),
        entry_count:
          entryToEdit?.category_name === formData?.category_name
            ? entryToEdit?.entry_count
            : assignSortId(allEntries),
        id:
          entryToEdit?.category_name === formData?.category_name
            ? entryToEdit?.id
            : assignSortId(allEntries),
        performance_time: myTime,
      };
    });
  }, [
    initialFormData,
    eligibilityDivisions,
    averageAge,
    allEntries,
    selectedDancers,
  ]);

  //============================================================================to handle studio search
  const [openSearchStudio, setOpenSearchStudio] = useState(false);

  function toggleOpenSearchStudio() {
    setOpenSearchStudio((prev) => !prev);
  }

  const [studioSearchTerm, setStudioSearchTerm] = useState("");

  const filteredStudios = studios?.filter((itm) =>
    itm?.studio_name?.toLowerCase()?.includes(studioSearchTerm?.toLowerCase())
  );

  //============================================================================to handle dancer search
  const [openSearchDancer, setOpenSearchDancer] = useState(false);

  function toggleOpenSearchDancer() {
    setOpenSearchDancer((prev) => !prev);
  }

  const [DancerSearchTerm, setDancerSearchTerm] = useState("");

  const filteredDaners = filteredDancerOptions?.filter(
    (itm) =>
      itm?.first_name
        ?.toLowerCase()
        ?.includes(DancerSearchTerm?.toLowerCase()) ||
      itm?.last_name?.toLowerCase()?.includes(DancerSearchTerm?.toLowerCase())
  );

  //===================================================to handle dancer select
  const handleSearchedDancerSelect = (dancerId) => {
    const newDancer = filteredDancerOptions?.filter(
      (each) => each.dancer_uid === dancerId
    )[0];

    const check = selectedDancers?.filter(
      (item) => item?.dancer_uid === dancerId
    );

    if (check?.length > 0) {
      // check if the dancer is already selected based on id
      setSelectedDancers((prevSelectedDancers) =>
        prevSelectedDancers.map((dancer) =>
          dancer?.dancer_uid === dancerId ? newDancer : dancer
        )
      );
    } else {
      setSelectedDancers([...selectedDancers, newDancer]);
    }
    setOpenDancers(false);
  };

  return (
    <>
      <form className="">
        <div className="w-full md:min-w-[400px] md:w-[500px] lg:min-w-[600px] bg-[#282929] rounded-xl p-4 sm:p-7 mb-[200px] mx-auto flex flex-col gap-4">
          <h2 className="font-bold text-white/80">Edit Entry</h2>
          <div
            className={`w-full p-3 rounded-lg bg-[#0c0c0d] flex flex-col transition-all duration-500 ${
              entryExists && "border border-red-400"
            } ${
              validationError &&
              !formData?.entry_name &&
              "border border-red-400"
            }`}
          >
            <div>
              <label
                htmlFor="entry_name"
                className="text-[.75rem] text-white/40"
              >
                Entry Name
              </label>
              <input
                type="text"
                id="entry_name"
                value={formData?.entry_name}
                onChange={handleFormChange}
                className="w-full bg-[#0c0c0d] outline-none text-white"
                placeholder="E.g. Bane"
              />
            </div>
          </div>
          <div className="w-full flex flex-col md:flex-row gap-3">
            <div
              className={`w-full h-fit md:w-1/2 px-3 py-4 rounded-lg bg-[#0c0c0d] flex flex-col transition-all duration-500 ${
                validationError &&
                selectedStudios?.length === 0 &&
                "border border-red-400"
              }`}
            >
              {/* to display serch studio input */}
              {openSearchStudio && (
                <EmceeEntrySearchCont
                  studioSearchTerm={studioSearchTerm}
                  setStudioSearchTerm={setStudioSearchTerm}
                  toggleOpenSearchStudio={toggleOpenSearchStudio}
                  filteredStudios={filteredStudios}
                  setSelectedStudios={setSelectedStudios}
                  studios={studios}
                  setSelectedDancers={setSelectedDancers}
                />
              )}

              {/* to display select studio input */}
              {!openSearchStudio && (
                <div className="flex gap-2 relative">
                  <label
                    htmlFor="select_studios"
                    className="w-full px-1 py-1 text-[.75rem] text-white/40 cursor-pointer rounded-md"
                    onClick={toggleOpenStudios}
                  >
                    Select Studio
                  </label>
                  {openStudios && (
                    <select
                      id="select_studios"
                      value={formData?.select_studios}
                      onChange={handleStudioChange}
                      className="w-2/3 p-2 bg-[#0c0c0d] outline-none text-white/80 absolute left-[-10px] top-10 rounded-md border border-white/50 z-[2]"
                      multiple
                    >
                      {studios?.map((item, index) => {
                        return (
                          <option
                            key={index}
                            className="hover:bg-[#94a4fd]/50 cursor-pointer"
                            value={item?.studio_name}
                            onClick={toggleOpenStudios}
                          >
                            {item?.studio_name}
                          </option>
                        );
                      })}
                    </select>
                  )}

                  {/* the open search studios button button */}
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleOpenSearchStudio();
                    }}
                    className="w-7 h-7 flex justify-center items-center p-1 absolute top-[-5px] right-0 bg-white/30 rounded-full cursor-pointer hover:bg-[#94a4fd]/50"
                  >
                    <img
                      alt="user"
                      src="/images/icons8-search-64.png"
                      className="w-5 h-5"
                    />
                  </div>
                </div>
              )}

              {selectedStudios?.length > 0 && (
                <div className="w-full mt-2 border-t border-white/20 pt-2">
                  <ul className="flex gap-2 flex-wrap">
                    {selectedStudios?.map((item, index) => (
                      <li
                        className="px-2 rounded-md bg-[#94a4fd]/30 text-[.85rem] flex gap-2 items-center text-white/80"
                        key={index}
                      >
                        <span>{item}</span>
                        <img
                          className="w-3 h-3 cursor-pointer"
                          alt="arrow"
                          src="/images/icons8-close-white-50.png"
                          onClick={() => handleRemoveStudio(item)}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <div className="w-full h-fit md:w-1/2">
              <div
                className={`w-full  px-3 py-4 rounded-lg bg-[#0c0c0d] flex flex-col transition-all duration-500 ${
                  openDancersErr && "border border-red-500/60"
                } ${
                  validationError &&
                  formData?.dancers_selected?.length === 0 &&
                  "border border-red-400"
                }`}
              >
                {/* to display serch dancer input */}
                {openSearchDancer && (
                  <EmceeEntryDancerSearchCont
                    DancerSearchTerm={DancerSearchTerm}
                    setDancerSearchTerm={setDancerSearchTerm}
                    toggleOpenSearchDancer={toggleOpenSearchDancer}
                    filteredDaners={filteredDaners}
                    handleSearchedDancerSelect={handleSearchedDancerSelect}
                    studios={studios}
                  />
                )}

                {!openSearchDancer && (
                  <div className="flex gap-2 relative">
                    <label
                      htmlFor="select_dancers"
                      className="w-full px-1 py-1 text-[.75rem] text-white/40 cursor-pointer rounded-md"
                      onClick={toggleOpenDancers}
                    >
                      Select Dancers
                    </label>
                    {searchingDancers && dancersFromStudios?.length === 0 && (
                      <div className="w-2/3 p-2 min-h-[100px] bg-[#0c0c0d] outline-none text-white/80 absolute left-[-10px] top-10 flex flex-col gap-2 justify-center items-center">
                        <p className="text-white/30 text-[.75rem]">
                          Fetching dancers..
                        </p>
                        <Spinner />
                      </div>
                    )}
                    {openDancers && !searchingDancers && (
                      <select
                        id="select_Dancers"
                        onChange={handleDancerChange}
                        className="w-2/3 p-2 min-h-[100px] bg-[#0c0c0d] outline-none text-white/80 absolute left-[-10px] top-10 rounded-md border border-white/50 z-[1]"
                        multiple
                      >
                        {filteredDancerOptions?.length > 0 ? (
                          filteredDancerOptions?.map((item, index) => {
                            return (
                              <option
                                key={index}
                                className="hover:bg-[#94a4fd]/50 cursor-pointer"
                                value={item?.dancer_uid}
                                onClick={toggleOpenDancers}
                              >
                                {item.first_name} {item.last_name}
                              </option>
                            );
                          })
                        ) : (
                          <option
                            disabled
                            className="text-[.85rem] text-white/60 mt-5 whitespace-normal"
                          >
                            {selectedStudios[0] +
                              " does not have dancers yet.."}
                          </option>
                        )}
                      </select>
                    )}

                    {/* the open search dancers button button */}
                    {selectedStudios?.length > 0 && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleOpenSearchDancer();
                        }}
                        className="w-7 h-7 flex justify-center items-center p-1 absolute top-[-5px] right-0 bg-white/30 rounded-full cursor-pointer hover:bg-[#94a4fd]/50"
                      >
                        <img
                          alt="user"
                          src="/images/icons8-search-64.png"
                          className="w-5 h-5"
                        />
                      </div>
                    )}
                  </div>
                )}

                {selectedDancers.length > 0 && (
                  <div className="w-full mt-2 border-t border-white/20 pt-2">
                    <ul className="flex gap-2 flex-wrap">
                      {selectedDancers?.map((dancer, index) => (
                        <li
                          className="px-2 rounded-md bg-[#94a4fd]/30 text-[.85rem] flex gap-2 items-center text-white/80"
                          key={index}
                        >
                          <span>
                            {dancer?.first_name} {dancer?.last_name}
                          </span>
                          <img
                            className="w-3 h-3 cursor-pointer"
                            alt="arrow"
                            src="/images/icons8-close-white-50.png"
                            onClick={() => handleRemoveDancer(dancer)}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              {openDancersErr && (
                <div className="text-red-500 text-center text-[.75rem]">
                  No studios selected
                </div>
              )}
            </div>
          </div>

          <div className="w-full flex gap-3">
            <div
              className={`w-full h-fit p-3 rounded-lg bg-[#0c0c0d] flex flex-col transition-all duration-500 ${
                validationError &&
                !formData?.age_division &&
                "border border-red-400"
              }`}
            >
              <div>
                <label
                  htmlFor="age_division"
                  className="text-[.75rem] text-white/40"
                >
                  Age Division
                </label>
                <div className="w-full bg-[#0c0c0d] outline-none text-white/80">
                  {/* to dynamically display entryType options based on age of dancers selected */}

                  {selectedDancers?.length > 0 &&
                    filteredAgeDivision(eligibilityDivisions, averageAge)[0]
                      ?.divisionName}

                  {selectedDancers?.length === 0 && (
                    <>
                      <option value="" disabled className="text-[.8em]">
                        Select at least 1 dancer..
                      </option>
                      <option value="" disabled className="text-[.8em]">
                        Age division auto-generated based on
                      </option>
                      <option value="" disabled className="text-[.8em]">
                        the ages of selected dancers.
                      </option>
                    </>
                  )}

                  {selectedDancers?.length > 0 &&
                    filteredAgeDivision(eligibilityDivisions, averageAge)
                      ?.length === 0 && (
                      <>
                        <option value="" disabled className="text-[.85rem]">
                          The dancers average age ({averageAge})
                        </option>
                        <option value="" disabled className="text-[.85rem]">
                          does not fall under any age division
                        </option>
                        <option value="" disabled className="text-[.85rem]">
                          in this competiton.
                        </option>
                      </>
                    )}
                </div>
              </div>
            </div>
            <div className="w-full flex gap-2">
              <div className="w-full h-fit border border-white/40 rounded-lg bg-white/20 p-3 text-[.85rem] text-white/60">
                Avg Age:{" "}
                <span className="font-medium">
                  {averageAge > 0 ? averageAge : ""}
                </span>
              </div>
              <ul className="w-full h-fit border border-white/40 rounded-lg bg-white/20 p-2 text-[.85rem] text-white/60">
                {competitionLevel?.map((item, index) => {
                  const key = item?.levelName;
                  return (
                    <li key={index}>
                      {item?.levelName} -{" "}
                      {calculatePercentageOfDancerLevel(selectedDancers)?.[key]
                        ? calculatePercentageOfDancerLevel(selectedDancers)?.[
                            key
                          ] + "%"
                        : "0%"}{" "}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          <div className="flex md:flex-row flex-col gap-4">
            <div className="w-full md:w-1/2">
              <div
                className={` p-3 rounded-lg bg-[#0c0c0d] flex flex-col transition-all duration-500 relative ${
                  validationError &&
                  !formData?.classification &&
                  "border border-red-400"
                }`}
              >
                <div>
                  <label
                    htmlFor="classification"
                    className="text-[.75rem] text-white/40"
                  >
                    Classification
                  </label>
                  <select
                    id="classification"
                    value={formData?.classification}
                    onChange={handleFormChange}
                    className="w-full bg-[#0c0c0d] outline-none text-white/70 cursor-pointer"
                  >
                    <option value="DEFAULT" disabled hidden>
                      Select
                    </option>
                    {competitionLevel?.map((item, index) => {
                      return (
                        <option key={index} value={item?.levelName}>
                          {item?.levelName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              {separateClass?.length > currentClass?.length &&
                formData?.classification && (
                  <div className="border-[#94a4fd] border p-2 bg-white/20 rounded-lg mt-2 text-[.85rem] text-white/70">
                    This entry contains dancer(s) in a different classification
                    than the one you have selected. Please confirm that you are
                    within competition rules before proceeding.
                  </div>
                )}
            </div>
            <div
              className={`w-full h-fit md:w-1/2 p-3 rounded-lg bg-[#0c0c0d] flex flex-col transition-all duration-500 relative ${
                validationError && !formData?.genre && "border border-red-400"
              }`}
            >
              <div>
                <label htmlFor="genre" className="text-[.75rem] text-white/40">
                  Genre
                </label>
                <select
                  id="genre"
                  value={formData?.genre}
                  onChange={handleFormChange}
                  className="w-full bg-[#0c0c0d] outline-none text-white/70 cursor-pointer"
                >
                  <option value="DEFAULT" disabled hidden>
                    Select
                  </option>

                  {trueGenreKeys?.map((item, index) => {
                    return (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

          <div className="flex md:flex-row flex-col gap-4">
            <div
              className={`w-full md:w-1/2 p-3 rounded-lg bg-[#0c0c0d] flex flex-col transition-all duration-500 relative   ${
                validationError &&
                !formData?.entryType &&
                "border border-red-400"
              }`}
            >
              <div>
                <label
                  htmlFor="entryType"
                  className="text-[.75rem] text-white/40"
                >
                  Entry type
                </label>
                <select
                  id="entryType"
                  value={formData?.entryType}
                  onChange={handleFormChange}
                  className="w-full bg-[#0c0c0d] outline-none text-white/70 cursor-pointer"
                >
                  <option value="DEFAULT" disabled hidden>
                    Select
                  </option>

                  {/* to dynamically display entryType options based on number of dancers selected */}
                  {selectedDancers?.length > 0 &&
                    filteredEntryTypes(
                      entryTypes,
                      selectedDancers?.length
                    )?.map((item, index) => {
                      return (
                        <option key={index} value={item?.entryTypeName}>
                          {item?.entryTypeName}
                        </option>
                      );
                    })}

                  {selectedDancers?.length === 0 && (
                    <>
                      <option value="" disabled className="text-[.85rem]">
                        Select at least 1 dancer..
                      </option>
                      <option value="" disabled className="text-[.85rem]">
                        EntryType is based on
                      </option>
                      <option value="" disabled className="text-[.85rem]">
                        number selected dancers.
                      </option>
                    </>
                  )}
                </select>
              </div>
            </div>
          </div>

          <div className="flex md:flex-row flex-col gap-4">
            <div className="w-full  md:w-1/2 p-3 rounded-xl bg-[#0c0c0d]">
              <p className="text-[.75rem] text-white/40">Special tags</p>
              <div
                className={`checkbox-container flex gap-5 mt-4 flex-wrap items-center checkbox-container`}
              >
                {tags?.map((value, index) => (
                  <div
                    key={index}
                    className="text-white/60 text-[.75em] flex items-center"
                  >
                    <input
                      type="checkbox"
                      name="checkboxes"
                      className="cursor-pointer"
                      value={value?.customTags}
                      checked={formData.special_tags?.includes(
                        value?.customTags
                      )}
                      onChange={handleCheckboxChange}
                    />
                    {value?.customTags}
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full  md:w-1/2">
              {/* <p className="text-[.75rem] text-white/40">Special tags</p> */}
              <div>
                <div
                  className={` p-3 rounded-xl bg-[#0c0c0d] checkbox-container`}
                >
                  <div className="text-white/60 text-[.75em] flex items-center">
                    <input
                      type="checkbox"
                      name="prop"
                      className="cursor-pointer"
                      checked={isCheckedProps}
                      onChange={handlePropChange}
                    />
                    Props / Set Piece
                  </div>
                </div>
                <div
                  className={` p-3 rounded-xl bg-[#0c0c0d] checkbox-container mt-3`}
                >
                  <div className="text-white/60 text-[.75em] flex items-center">
                    <input
                      type="checkbox"
                      name="dancerStarts"
                      className="cursor-pointer"
                      checked={isDancerStarts}
                      onChange={handleDancerStartsChange}
                    />
                    Dancer starts on stage
                  </div>
                </div>
                <div
                  className={` p-3 rounded-xl bg-[#0c0c0d] checkbox-container mt-3`}
                >
                  <div className="text-white/60 text-[.75em] flex items-center">
                    <input
                      type="checkbox"
                      name="dancerStarts"
                      className="cursor-pointer"
                      checked={isRunAround}
                      onChange={handleRunAroundChange}
                    />
                    Run around
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full flex flex-col gap-3">
            <h2 className="font-bold text-white/80">Upload Music</h2>
            {musicUrl ? (
              <p className="font-bold text-white/50">
                Music uploaded: {musicUrl}
              </p>
            ) : (
              <p className="font-bold text-white/50">No music uploaded</p>
            )}
            <input
              type="file"
              id="music"
              accept="audio/*"
              className="w-[70%] p-2 bg-[#0c0c0d] outline-none text-white rounded-xl"
              placeholder="Select file"
              onChange={(e) => setMusicFile(e.target.files[0])}
            />
            <button
              className="flex w-fit text-[.9rem] px-5 py-1 rounded-lg bg-[#94a4fd] hover:bg-[#94a4fd]/80 text-[#1c1c1c] transition-all duration-300"
              disabled={loading}
              onClick={handleMusicUpload}
            >
              {loading ? (
                <>
                  <span className="text-white mr-2">
                    Uploading {uploadProgress}%
                  </span>
                  <ButtonLoadingSpinner className="ml-2" />
                </>
              ) : (
                "Upload Music"
              )}
            </button>
            {uploadComplete && <p>Upload Complete: {uploadComplete}</p>}
          </div>

          {validationError && (
            <div className="w-full text-red-400 text-[.85rem] border border-red-500 bg-red-400/10 mt-5 px-3 py-2 rounded-xl">
              PLease fill all fields
            </div>
          )}
          {entryExists && (
            <div className="w-full text-red-400 text-[.85rem] border border-red-500 bg-red-400/10 mt-5 px-3 py-2 rounded-xl">
              Entry with entry name "{formData?.entry_name}" already exists in
              this event...
            </div>
          )}

          <div className="w-full mx-auto mt-7 text-end">
            <button
              onClick={() => {
                // handleDiscard();
                setOpenEdit(false);
              }}
              className="text-[.85rem] px-5 py-1 mr-4 rounded-lg bg-[#c5c4c4] hover:bg-[#c5c4c4]/60 text-[#1c1c1c] transition-all duration-300"
            >
              Discard
            </button>
            <button
              onClick={(e) => {
                handleSubmit(e);
              }}
              disabled={editEntryPending}
              className={`text-[.9rem] px-5 py-1 rounded-lg bg-[#94a4fd] hover:bg-[#94a4fd]/80 text-[#1c1c1c] transition-all duration-300 ${
                editEntryPending || loading
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              {editEntryPending ? "Editing..." : "Save Changes"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default EmceeEditEntry;
